// 使用全局的axios变量
const axios = window.axios;

// 创建axios实例
const service = axios.create({
  baseURL: '', // api的base_url，使用相对路径
  timeout: 20000, // 请求超时时间ms
  withCredentials: true, // 跨域请求时是否需要使用凭证
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
});

// 请求拦截器
service.interceptors.request.use(
  config => {

    const token = localStorage.getItem("token");
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);
// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    const res = response.data;

    if (res.code == 401) {

      window.confirm('登录过期，是否重新登陆?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('username');

        location.reload();
      }).catch(() => {
        console.log('用户取消了重新登录');

      });
    }

    return res;
  },

error => {
  // 对响应错误做点什么
  console.error('响应错误:', error);

  // 处理响应状态码
  const { response } = error;
  if (response) {
    switch (response.status) {
      case 403:
        // 权限不足
        console.error('权限不足');
        break;
      case 404:
        console.error('请求的资源不存在');
        break;
      case 500:
        console.error('服务器错误');
        break;
      default:
        console.error(`未知错误: ${response.status}`);
    }
  } else {
    // 网络错误或请求被取消
    console.error('网络错误或请求被取消');
  }

  return Promise.reject(error);
}
);

// 封装GET请求
export function get(url, params = {}) {
  return service({
    url,
    method: 'get',
    params
  });
}

// 封装POST请求
export function post(url, data = {}) {
  return service({
    url,
    method: 'post',
    data
  });
}

// 封装PUT请求
export function put(url, data = {}) {
  return service({
    url,
    method: 'put',
    data
  });
}

// 封装DELETE请求
export function del(url, params = {}) {
  return service({
    url,
    method: 'delete',
    params
  });
}

// 封装上传文件请求
// export function upload(url, file) {
//   let fileObj = formDataToObject(file);
//   console.log(fileObj);

//   return service({
//     url,
//     method: 'post',
//     data: fileObj,
//     headers: {
//       'Content-Type': 'multipart/form-data'
//     }
//   });
// }

export function upload(url, formData) {
  return service({
    url,
    method: 'post',
    data: formData
  });
}
function formDataToObject(formData) {
  // 创建一个空对象
  const obj = {};

  // 使用 for...of 遍历 FormData
  for (const [key, value] of formData.entries()) {
    // 如果键已存在且是数组，则追加值；否则直接赋值
    if (obj[key]) {
      if (Array.isArray(obj[key])) {
        obj[key].push(value);
      } else {
        obj[key] = [obj[key], value];
      }
    } else {
      obj[key] = value;
    }
  }

  return obj;
}
// 导出axios实例
export default service;
